import { getViewAndUpdatePaymentMethodsCTA } from "./shared";
export var ChangeDefaultPaymentMethodIA = function ChangeDefaultPaymentMethodIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return CHANGE_DEFAULT_PAYMENT_METHOD(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [CHANGE_DEFAULT_PAYMENT_METHOD_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewAndUpdatePaym;
        return (_getViewAndUpdatePaym = getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)) === null || _getViewAndUpdatePaym === void 0 ? void 0 : _getViewAndUpdatePaym.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewAndUpdatePaym2, _getViewAndUpdatePaym3;
        return (_getViewAndUpdatePaym2 = getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)) === null || _getViewAndUpdatePaym2 === void 0 ? void 0 : (_getViewAndUpdatePaym3 = _getViewAndUpdatePaym2.getLink) === null || _getViewAndUpdatePaym3 === void 0 ? void 0 : _getViewAndUpdatePaym3.call(_getViewAndUpdatePaym2);
      }
    }
  };
};
var CHANGE_DEFAULT_PAYMENT_METHOD = function CHANGE_DEFAULT_PAYMENT_METHOD(strictLocalize) {
  return strictLocalize({
    id: "Qyd4db",
    defaultMessage: [{
      "type": 0,
      "value": "Modifier le mode de paiement par défaut"
    }]
  });
};
var CHANGE_DEFAULT_PAYMENT_METHOD_EXPLANATION = function CHANGE_DEFAULT_PAYMENT_METHOD_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "fENhjU",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez changer le mode de paiement par défaut en cliquant sur le bouton ci-dessous. Le mode de paiement indiqué par défaut à la date d'échéance de votre facture est celui qui sera utilisé. En cas d'échec de paiement avec votre mode de paiement par défaut, l'autre mode de paiement que vous avez indiqué pourra être débité."
    }]
  });
};